export const stats = [
  { value: '+60', label: 'Units Ready' },
  { value: '+2,000', label: 'Teachers Satisfied' },
  { value: '3,500+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+60', label: 'Ready-to-Teach Units' },
  { value: '10', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours planning every single math class',
  'Repetitive and dry exercises',
  'No clear connection to the real world',
  'Not knowing how to grade or assess properly',
  'Unmotivated students who "hate math"',
]

export const afterItems = [
  "5-minute review and you're set",
  'Visual and engaging math projects',
  'Real-world applications integrated',
  'Quizzes, exams, and answer keys ready',
  'Students mastering concepts with confidence',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriving to class without knowing exactly how to explain a complex topic',
  },
  {
    emoji: '⏱️',
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    emoji: '🤷',
    text: 'Struggling to find math worksheets that are actually high-quality and visual',
  },
  {
    emoji: '📋',
    text: 'No clear assessments or rubrics aligned with the school year',
  },
  {
    emoji: '😴',
    text: "Students falling behind because the material isn't connected",
  },
  { emoji: '🌙', text: 'Still not ready for Monday by Sunday night' },
]

export const packItems = [
  {
    emoji: '📚',
    title: '5 Primary Volumes (Grades 1–5)',
    text: 'A full elementary year fully planned',
  },
  {
    emoji: '🏛️',
    title: '5 Secondary Volumes (Grades 6–10)',
    text: 'From basic algebra to calculus foundations',
  },
  {
    emoji: '✏️',
    title: 'Step-by-Step Lesson Scripts',
    text: 'Ready to follow and teach in seconds',
  },
  {
    emoji: '📐',
    title: 'Visual Theory & Worksheets',
    text: 'High-quality graphics ready to print',
  },
  {
    emoji: '📊',
    title: 'Assessments & Final Exams',
    text: 'Complete tools for every single grade',
  },
  {
    emoji: '🔑',
    title: 'Full Answer Keys',
    text: 'Grading is finally instant and stress-free',
  },
]

export const instantItems = [
  'The 10 complete digital volumes (Primary and Secondary Series)',
  'Activities, projects, and assessments by level',
  'Step-by-step visual lessons for every mathematical concept',
  'Teacher scripts that tell you exactly what to say',
  'Answer keys for every worksheet and exam in the system',
]

export const bonuses = [
  {
    title: 'The 10-Minute Math Ready Setup Guide',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/15f9d9fe-5740-44a8-84a9-b8a2dfdae7f6.jpg',
  },
  {
    title: 'The Mental Math Warm-Up Vault (100 Prompts)',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7d472769-7ebe-45d4-8854-8cf06f25e37c.jpg',
  },
  {
    title: 'The Real-World Math Hook Bank (50 Scenarios)',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6e32f8f1-b78d-4071-b672-aaf79c77da8e.jpg',
  },
  {
    title: 'The Differentiation Quick-Fix Matrix',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c9cd780c-e429-42c5-bd30-c8084aba3a9d.jpg',
  },
  {
    title: 'The Parent Update & Progress Pack',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3fed2a43-aa7e-4d8f-b949-9026d0cd5fd4.jpg',
  },
]

export const offerRows = [
  { label: 'Math Ready Pack (10 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Bonuses', value: '$135' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The progression from Grade 1 to 10 is exactly what I needed.',
    name: 'Sarah M.',
    location: 'USA 🇺🇸',
  },
  {
    quote:
      'The visual lessons make a huge difference for my students who used to struggle.',
    name: 'Ella B.',
    location: 'UK 🇬🇧',
  },
  {
    quote:
      'The differentiation matrix alone saved my class this year. Worth every penny.',
    name: 'Maya K.',
    location: 'Canada 🇨🇦',
  },
  {
    quote:
      'Finally, a math resource that is actually organized and ready to print.',
    name: 'Sophie L.',
    location: 'Australia 🇦🇺',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instantly via email after purchase.',
  },
  {
    q: "Does this work if I'm a beginner teacher?",
    a: 'Yes, the scripts make it open-and-go.',
  },
  {
    q: 'What grade levels does this cover?',
    a: 'Full coverage from Grade 1 through Grade 10.',
  },
  {
    q: 'Are the bonuses included in the price?',
    a: 'Yes, only during this launch offer.',
  },
  {
    q: 'What file format are the volumes in?',
    a: 'High-resolution, print-ready PDF files.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. One-time payment, lifetime access.',
  },
]
